<template>
  <div class="cases">
    <div class="cases-main">
      <div class="cases-title" data-aos="fade-up" data-aos-duration="1000">
        <h3>解决方案</h3>
        <p>针对行业特征及业务场景深度定制，打造一站式解决方案</p>
      </div>
      <div class="cases-content">
        <div class="cases-left animated" id="tit" data-aos="fade-right" data-aos-duration="1000" data-aos-delay="200">
          <h2 class="cases-left-tit animated">{{ theContent.tit }}</h2>
          <p class="cases-left-desc animated" id="desc">{{ theContent.desc }}</p>
          <div class="cases-left-tx animated" id="tx">
            <div class="cases-left-txitem" v-for="(item, index) in theContent.tx">{{ item.text }}</div>
          </div>
          <div class="cases-left-btn animated" @click="toDetail(theContent.url)" id="btn">了解详情</div>
          <h3 class="cases-left-tits animated" id="tits" v-if="['数据中心定制', '机房搬迁'].indexOf(theContent.tit) < 0">客户案例</h3>
          <div class="cases-left-brands animated" id="brands">
            <img v-for="(item, index) in theContent.brands" :src="item.src" :style="item.style" />
          </div>
        </div>
        <div class="cases-right" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
          <div class="cases-right-wrap">
            <div :class="index == 0 ? 'cases-right-item cri-active' : 'cases-right-item'" @click="switchIndex(0)">算力服务解决方案</div>
            <div :class="index == 1 ? 'cases-right-item cri-active' : 'cases-right-item'" @click="switchIndex(1)">数据中心定制解决方案</div>
            <div :class="index == 2 ? 'cases-right-item cri-active' : 'cases-right-item'" @click="switchIndex(2)">机房搬迁解决方案</div>
            <div :class="index == 3 ? 'cases-right-item cri-active' : 'cases-right-item'" @click="switchIndex(3)">混合云解决方案</div>
            <div :class="index == 4 ? 'cases-right-item cri-active' : 'cases-right-item'" @click="switchIndex(4)">信息安全解决方案</div>

            <p class="cases-right-text">……</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      index: 0,
      theContent: {},
      content: [
        {
          tit: "算力服务",
          desc: "在数据驱动的世界中，我们提供最先进GPU技术的算力资源池解决方案。从集群规划到运维维护，我们提供全套服务，帮助客户解锁AI、机器学习和大数据处理的潜力。",
          tx: [{ text: "高性能与灵活性" }, { text: "成本效益优化" }, { text: "高稳定性与安全性" }],
          url: "/resource/ComputePower",
          brands: [
            {
              src: require("../../../assets/home/cases/pubinfo.png"),
              style: "height:30px;background:none;padding:4px",
            },

            {
              src: require("../../../assets/home/cases/unicom.png"),
              style: "height:30px;background:none;padding:4px",
            },
          ],
        },
        {
          tit: "数据中心定制",
          desc: "高度个性化定制，满足多元化的需求。 高度个性化定制，满足多元化的需求。 曾仅耗时63天，为互联网龙头企业设计与建设整座数据中心。",
          tx: [{ text: "建设迅速" }, { text: "成本节约" }, { text: "100%定制" }],
          url: "/solution/dataCenter",
          brands: [
            {
              src: require("../../../assets/home/cases/qn.jpg"),
              style: "width:75px;height:26px",
            },

            {
              src: require("../../../assets/home/cases/tongdun.png"),
              style: "width:108px;height:27px",
            },
          ],
        },
        {
          tit: "机房搬迁",
          desc: "平滑迁移IT设备，高效安全，风险可控",
          tx: [{ text: "机房搬迁服务" }, { text: "同城搬迁" }, { text: "异地搬迁" }],
          url: "/solution/DCmove",
        },
        {
          tit: "混合云服务",
          desc: "网银互联提供安全、可靠、稳定、高速的入云产品，通过物理专线实现企业自有数据中心快速接通云上资源，且现有专线网络资源已与阿里云、腾讯云、AWS等云厂商打通，部署灵活简便。",
          tx: [{ text: "云专线" }, { text: "多云互联" }, { text: "云网融合" }, { text: "云交换平台" }],
          url: "/solution/ConAndMix",
          brands: [
            {
              src: require("../../../assets/home/cases/tss.png"),
              style: "width:75px;height:26px",
            },

            {
              src: require("../../../assets/home/cases/tongdun.png"),
              style: "width:108px;height:27px",
            },
            {
              src: require("../../../assets/home/cases/huichuan.png"),
              style: "width:78px;height:30px",
            },
          ],
          prods: [
            {
              icon: "iconfont icon-quanqiu",
              size: "font-size:22px",
              text: "云数据同步服务",
            },
            {
              icon: "iconfont icon-guganwang-01",
              size: "font-size:22px",

              text: "IDC数据同步服务",
            },
            {
              icon: "iconfont icon-gongyouyunhoutaisvg",
              size: "font-size:18px",
              text: "公有云",
            },
            {
              icon: "iconfont icon-rongqi",
              size: "font-size:20px",
              text: "容器云",
            },
            {
              icon: "iconfont icon-siyouyun",
              size: "font-size:28px",
              text: "私有云",
            },
            {
              icon: "iconfont icon-rongzai",
              size: "font-size:20px",
              text: "数据容灾",
            },
            {
              icon: "iconfont icon-icon_BigData",
              size: "font-size:22px",
              text: "大数据",
            },
            {
              icon: "iconfont icon-qiyeanquanzicha",
              size: "font-size:20px",
              text: "企业安全",
            },
            {
              icon: "iconfont icon-anquan",
              size: "font-size:22px",
              text: "等保",
            },
            {
              icon: "iconfont icon-yunguanli",
              size: "font-size:20px",
              text: "多云管理平台",
            },
          ],
        },
        {
          tit: "信息安全",
          desc: "网银互联已整合深信服、安恒等诸多安全厂商的安全产品资源，可以为客户提供一站式企业信息安全解决方案。",
          tx: [{ text: "一站式服务" }, { text: "广泛适用" }, { text: "独立管控" }, { text: "智能编排" }],
          url: "/solution/entSecurity",
          brands: [
            {
              src: require("../../../assets/home/cases/brandd1.png"),
              style: "height:34px",
            },
            {
              src: require("../../../assets/home/cases/brandd2.png"),
              style: "height:24px",
            },

            {
              src: require("../../../assets/home/cases/brandd4.png"),
              style: "height:30px",
            },
            {
              src: require("../../../assets/home/cases/brandd5.png"),
              style: "height:30px",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.switchIndex(0);
  },
  methods: {
    toDetail(url) {
      if (url) {
        let a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("id", "startTelMedicine");
        // 防止反复添加
        if (document.getElementById("startTelMedicine")) {
          document.body.removeChild(document.getElementById("startTelMedicine"));
        }
        document.body.appendChild(a);
        a.click();
      }
    },
    switchIndex(index) {
      this.index = index;
      if (index < 5) this.theContent = this.content[index];

      // $("#tit").removeClass("fadeInRight");
      // $("#desc").removeClass("fadeInRight");
      // $("#tx").removeClass("fadeInRight");
      // $("#btn").removeClass("fadeInRight");
      // $("#tits").removeClass("fadeInRight");
      // $("#brands").removeClass("fadeInRight");

      $("#tit").addClass("fadeInRight");
      setTimeout(function() {
        $("#tit").removeClass("fadeInRight");
      }, 800);
      // $("#desc").addClass("fadeInRight");
      // setTimeout(function() {
      //   $("#desc").removeClass("fadeInRight");
      // }, 1000);
      // $("#tx").addClass("fadeInRight");
      // setTimeout(function() {
      //   $("#tx").removeClass("fadeInRight");
      // }, 1200);
      // $("#btn").addClass("fadeInRight");
      // setTimeout(function() {
      //   $("#btn").removeClass("fadeInRight");
      // }, 1400);
      // $("#tits").addClass("fadeInRight");
      // setTimeout(function() {
      //   $("#tits").removeClass("fadeInRight");
      // }, 1600);
      // $("#brands").addClass("fadeInRight");
      // setTimeout(function() {
      //   $("#brands").removeClass("fadeInRight");
      // }, 1800);
      //   $("#tit").addClass("fadeInRight");
      //    setTimeout(function(){
      //   $("#tit").removeClass("fadeInRight");
      // }, 600);
      //   $("#tit").addClass("fadeInRight");
      //    setTimeout(function(){
      //   $("#tit").removeClass("fadeInRight");
      // }, 600);
      //   $("#tit").addClass("fadeInRight");
      //    setTimeout(function(){
      //   $("#tit").removeClass("fadeInRight");
      // }, 600);
    },
  },
};
</script>
<style lang="less" scoped>
.cases {
  height: 690px;
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  margin-top: 30px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  background-image: url("../../../assets/home/cases/bg.jpg");
  background-color: #fff;
}
.cases-main {
  height: 100%;
  width: 1200px;
  margin: 0 auto;
  .cases-title {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 20px;
    text-align: center;
    padding-top: 70px;
    h3 {
      font-size: 28px;
      color: #fff;
    }
    p {
      margin-top: 20px;
      font-size: 16px;
      font-weight: 300;
      color: #aba1a2;
    }
  }
  .cases-content {
    width: 1160px;
    // height: 600px;
    // background-color: #fff;
    .cases-left {
      width: 890px;
      padding-top: 20px;
      padding-left: 80px;
      float: left;
      .cases-left-tit {
        height: 23px;
        font-size: 24px;
        color: #fff;
      }
      .cases-left-desc {
        width: 750px;
        margin-top: 30px;
        font-weight: 300;
        line-height: 30px;
        font-size: 16px;
        color: #fff;
      }
      .cases-left-tx {
        display: -webkit-flex; /* Safari */
        display: flex;
        justify-content: flex-start;
        margin-top: 20px;
        .cases-left-txitem {
          width: fit-content;
          height: 30px;
          color: #fff;
          padding: 0 10px;
          font-weight: 300;
          line-height: 30px;
          text-align: center;
          margin-right: 20px;
          background-color: rgba(255, 255, 255, 0.2);
        }
      }
      .cases-left-btn {
        width: 100px;
        height: 28px;
        color: #fff;
        margin: 35px 0;
        cursor: pointer;
        font-size: 14px;
        font-weight: 300;
        text-align: center;
        line-height: 28px;
        background: #c3191f;
        border-radius: 5px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      }
      .cases-left-tits {
        color: #fff;
        font-weight: 300;
        font-size: 18px;
        margin-bottom: 20px;
      }
      .cases-left-brands {
        height: 60px;
        margin-bottom: 20px;
        display: -webkit-flex; /* Safari */
        display: flex;
        align-items: center;
        justify-content: flex-start;
        img {
          margin-right: 30px;
        }
      }
      .cases-left-prods {
        display: -webkit-flex; /* Safari */
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        .cases-left-proditems {
          margin-right: 18px;
          margin-bottom: 20px;
          width: 130px;
          // img {
          //   width: 26px;
          //   height: 30px;
          //   float: left;
          //   margin-right: 5px;
          // }
          display: flex;
          display: -webkit-flex;
          .icon {
            width: 30px;
            height: 30px;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            i {
              font-size: 22px;
              font-weight: bold;
              background-image: -webkit-linear-gradient(top, #b80416, #b80416, #ea4137);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          .text {
            color: #fff;
            float: left;
            font-size: 14px;
            line-height: 30px;
          }
        }
      }
    }
    .cases-right {
      width: 250px;
      // height: 600px;
      height: 440px;
      float: right;
      font-weight: 300;
      border: 2px solid #df4c44;
      position: relative;
      .cases-right-wrap {
        position: absolute;
        right: 0;
        top: 35px;
        .cases-right-item {
          width: 255px;
          margin-bottom: 15px;
          padding-left: 75px;
          line-height: 50px;
          font-size: 18px;
          color: #fff;
          transition: all 0.3s;
          cursor: pointer;
        }
        .cases-right-text {
          width: 260px;
          margin-bottom: 5px;
          padding-left: 20px;
          line-height: 50px;
          font-size: 18px;
          color: #fff;
          text-align: center;
        }
        .cri-active {
          background-image: linear-gradient(90deg, rgb(190, 25, 30), rgba(0, 0, 0, 0.1));
        }
      }
    }
  }
}

#desc {
  animation-delay: 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/cases.vue